import { JumpstartSpinCommand } from "slotworks/commands/comms/jumpstart-spin-command";
import { RecoverState } from "slotworks/state-machine/standard/states/recover-state";

export class RecoverSpinState extends RecoverState {
    public onEnter() {
        JumpstartSpinCommand().execute();

        super.onEnter();
    }
}
